/**
 * App icon shortcuts are native-only (iOS Quick Actions / Android App Shortcuts).
 */
export const useAppShortcuts = (_args: { isAppReady: boolean }) => {
  // no-op on web
};
